module.exports = __webpack_public_path__ + "static/nxrt-automotive2-d3448d5ce109ee9ad5d01119e2d77c2d.jpg";